// Module
var code = `<div class="labelled-field labelled-field--long">
  <label for="filter-date" aria-hidden="true">Date range</label>
  <input id="filter-date" type="text" class="form-control daterange">
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/date-range-picker/date-range-picker.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;